import { autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { OnboardingClientService } from "../../../../../services/onboarding/onboarding-client.service";
import { UrlHelper } from "../../../../../helpers/url-helper";
import { OnboardingSession } from "../../onboarding.session";

@autoinject()
export class ContinueFromMobileDialog {

    loading: boolean;

    constructor(private dialogClientService: DialogClientService,
        private onboardingClientService: OnboardingClientService,
        private onboardingSession: OnboardingSession) { }

    urlGenerated: string;

    activate() {
        this.loading = true;
        const url = location.href.split('?')[0] + "?" + UrlHelper.getQueryString(window["onboardingRequestUrlMeta"]);
        this.onboardingClientService.shortenUrl(url).then(response => {
            if (this.onboardingSession.onboardingRequestGuid) {
                this.onboardingClientService.saveUrlsHistory(this.onboardingSession.onboardingRequestGuid, this.onboardingSession.getUrlsHistory()).then(() => {
                    this.urlGenerated = response;
                });
            } else {
                this.urlGenerated = response;
            }
            setTimeout(() => {
                this.loading = false;
            })
        });
    }

    close() {
        this.dialogClientService.hide();
    }
}
